import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseImg from "../../images/close.svg";

export default function WarningMsg(props) {
  const { messageContent } = props;
  const [state, setState] = React.useState({
    open: true,
    vertical: "bottom",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;

  const handleClose = () => {
    props.hideModal();
    setState({ ...state, open: false });
  };

  return (
    <Snackbar
      className="relative"
      anchorOrigin={{ vertical, horizontal }}
      open={open}
      onClose={handleClose}
      key={vertical + horizontal}
      ContentProps={{
        sx: {
          bgcolor: "white",
          color: "black",
          width: "100%",
          padding: 2,
          boxSizing: "border-box",
        },
      }}
      message={messageContent}
      action={
        <div onClick={()=>props.hideModal()} style={{cursor:"pointer", position:"absolute", top:"4px", right:"4px"}}>
          <img className="w-6" src={CloseImg} alt="" />
        </div>
      }
    />
  );
}
